/**
 * Category Loader
 * Shows a loading indicator when switching between vehicle categories
 */

document.addEventListener('DOMContentLoaded', () => {
    const categoryLinks = document.querySelectorAll('[data-category-link]');

    if (categoryLinks.length === 0) return;

    categoryLinks.forEach(link => {
        link.addEventListener('click', () => {
            // Show loader
            showLoader();
        });
    });
});

function showLoader() {
    // Create loader overlay if it doesn't exist
    let loader = document.getElementById('category-loader');

    if (!loader) {
        loader = document.createElement('div');
        loader.id = 'category-loader';
        loader.className = 'fixed top-0 left-0 w-full h-full z-[9999] flex items-center justify-center bg-white/95';
        loader.innerHTML = `
            <div class="flex flex-col items-center gap-6">
                <div class="w-16 h-16 border-4 border-gray-200 border-t-[var(--primary-color)] rounded-full animate-spin"></div>
                <div class="text-[1.6rem] font-semibold text-[var(--primary-color)] tracking-wider">Cargando...</div>
            </div>
        `;
        document.body.appendChild(loader);
    }

    loader.classList.remove('hidden');
    loader.style.display = 'flex';

    // Block scroll on both body and html
    document.documentElement.classList.add('overflow-hidden');
    document.body.classList.add('overflow-hidden');
}
